import { render, staticRenderFns } from "./Exams.vue?vue&type=template&id=13c6e4f0"
import script from "./Exams.vue?vue&type=script&lang=js"
export * from "./Exams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13c6e4f0')) {
      api.createRecord('13c6e4f0', component.options)
    } else {
      api.reload('13c6e4f0', component.options)
    }
    module.hot.accept("./Exams.vue?vue&type=template&id=13c6e4f0", function () {
      api.rerender('13c6e4f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/exam/Exams.vue"
export default component.exports